<template>
  <div>
    <el-container style="width: 880px; margin: 0 auto">
      <el-aside style="width: 90px; margin-top: 10px">
        <el-menu
          router
          :default-active="leftActiveIndex"
          class="el-menu-vertical-demo"
        >
          <el-menu-item
            v-for="item in leftMenus"
            :index="item.index"
            :route="item.path"
          >
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view> </router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "leftMain",
  data() {
    return {
      leftMenus: [],
      leftActiveIndex: "2-1",
      leftMenu: "/price",
    };
  },
  methods: {
    getMenu() {
      let that = this;
      let menus = [];
      let user = this.$store.getters["user"];
      menus = localStorage.getItem("menu_" + user.accountNo);
      if (menus != null) {
        menus = JSON.parse(menus);
      } else {
        menus = that.$store.getters["defaultMenu"];
      }
      let def = menus.filter((item) => {
        if (item.isCheck) {
          return item;
        }
      });
      def = this._.orderBy(def, ["level"], ["asc"]);
      this.leftMenus = def;
      this.leftActiveIndex = this.leftMenus[0].index;
    },
  },
  mounted() {
    this.getMenu();
  },
};
</script>

<style scoped>
/deep/ .el-menu-item {
  padding: 0 5px !important;
}
</style>
